// extracted by mini-css-extract-plugin
module.exports = {"root":"ChatInput_root__10PiO","send":"ChatInput_send__3eRij","input":"ChatInput_input__3VHIl","disabled":"ChatInput_disabled__2dCZu"};